(function(window, $) {
    'use strict';

    $(function($) {
        var $select2,
            old_tb_remove;

        if($('#widgets-left').length) {
            $(document).ajaxComplete(function(event, XMLHttpRequest, ajaxOptions) {
                var request = {},
                    pairs = ajaxOptions.data.split('&'),
                    i,
                    split,
                    widget;

                for (i in pairs) {
                    split = pairs[i].split('=');
                    request[decodeURIComponent(split[0])] = decodeURIComponent(split[1]);
                }

                if (request.action && request.action === 'save-widget') {
                    widget = $('input.widget-id[value="' + request['widget-id'] + '"]').parents('.widget');

                    // Trigger manual save, if this was the save request and if we didn't get the form html response.
                    if (!XMLHttpRequest.responseText) {
                        wpWidgets.save(widget, 0, 1, 0);
                    } else {
                        // We got a response, this could be either our request above, or a correct widget-save call, so fire an event on which we can hook our code.
                        $(document).trigger('saved_widget', widget);
                    }
                }
            });

            // enhance the drop down whenever the html is added to the page
            $(document).bind('saved_widget', function() {
                enhanceDropDown();
            });
        }

        // enhance drop down on startup
        enhanceDropDown();

        // add select 2 to drop down boxes
        function enhanceDropDown() {
            $('.supapress-dropdown').each(function (e, i) {
                $select2 = $(i).select2({width: '100%'}).on('select2:select', function() {
                    $('#TB_ajaxContent').find('.notice').remove();
                });
                if($select2.data('select2').$dropdown) {
                    $select2.data('select2').$dropdown.addClass("supapress-select2-drop");
                } else if($select2.data('select2').dropdown) {
                    $select2.data('select2').dropdown.addClass("supapress-select2-drop");
                }
            });

            old_tb_remove = window.tb_remove;
            window.tb_remove = function() {
                if($select2) {
                    $select2.select2('close');
                }
                old_tb_remove();
            };
        }

        // Add shortcode in WordPress post editor.
        $('#supapress-insert-shortcode').on('click', function(e) {
            e.preventDefault();

            var $chosenOption = $('#supapress-choose-module'),
                elt = $chosenOption.get(0),
                $tbContent = $('#TB_ajaxContent'),
                text;

            // Remove any previous errors
            $tbContent.find('.notice').remove();

            if (elt.selectedIndex === -1) {
                text = '';
                return false;
            } else if (!$chosenOption.val()) {
                $('<div class="notice notice-error"><p>Please select a module from the list</p></div>').insertAfter($tbContent.find('h1'));
                return false;
            } else {
                text = elt.options[elt.selectedIndex].text;
            }

            wp.media.editor.insert('[supapress id="' + $chosenOption.val() + '" title="' + text + '"]');
            tb_remove();
        });
    });
})(window, jQuery);
